import { Compass, ArrowUpRight } from "lucide-react";

const COLUMNS = [
  {
    title: "Platform",
    links: [
      { label: "tourism-connect.com", href: "https://tourism-connect.com" },
      { label: "booking.tourism-connect.com", href: "https://booking.tourism-connect.com" },
      { label: "Partner waitlist", href: "#waitlist" },
    ],
  },
  {
    title: "Destinations",
    links: [
      { label: "Botswana", href: "#destinations" },
      { label: "Namibia", href: "#destinations" },
      { label: "South Africa", href: "#destinations" },
      { label: "Zimbabwe", href: "#destinations" },
    ],
  },
  {
    title: "Contact",
    links: [
      { label: "hello@tourism-connect.com", href: "mailto:hello@tourism-connect.com" },
      { label: "Partnerships", href: "#waitlist" },
      { label: "Gaborone · Maun · Windhoek", href: "#top" },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="border-t border-goldline bg-coal/60">
      <div className="mx-auto max-w-7xl px-4 py-16 sm:px-8 lg:px-16">
        <div className="grid gap-12 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-full border border-gold/40 bg-gold/10">
                <Compass className="text-gold" size={18} />
              </span>
              <span className="font-serif text-xl font-semibold">
                Tourism<span className="text-gold"> Connect</span>
              </span>
            </div>
            <p className="mt-6 max-w-sm font-serif text-2xl italic leading-relaxed text-muted">
              "Where wild landscapes meet the business of endless adventure."
            </p>
          </div>

          {COLUMNS.map((col) => (
            <div key={col.title} className="lg:col-span-2">
              <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-gold/80">{col.title}</p>
              <ul className="mt-5 space-y-3">
                {col.links.map((l) => (
                  <li key={l.label}>
                    <a
                      href={l.href}
                      target={l.href.startsWith("http") ? "_blank" : undefined}
                      rel={l.href.startsWith("http") ? "noopener noreferrer" : undefined}
                      className="group inline-flex items-center gap-1 text-sm text-muted transition-colors duration-300 hover:text-gold"
                    >
                      {l.label}
                      {l.href.startsWith("http") && (
                        <ArrowUpRight size={12} className="opacity-0 transition-opacity duration-300 group-hover:opacity-100" />
                      )}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-16 flex flex-col items-center justify-between gap-4 border-t border-line pt-8 sm:flex-row">
          <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-subtle">
            © 2026 Tourism Connect. All rights reserved.
          </p>
          <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-subtle">
            Crafted for Southern Africa
          </p>
        </div>
      </div>
    </footer>
  );
}
